import styles from "./PolicyCard.module.css";

export default function PolicyCard({
icon,
title,
subtitle,
onClick
}) {

return (

<div
className={styles.card}
onClick={onClick}
>

<div className={styles.glow}></div>

<div className={styles.icon}>
{icon}
</div>

<h2>
{title}
</h2>

<p>
{subtitle}
</p>

</div>

);

}